export const API = {
  admin: {
    login: "/admin/login",
    logout: "/admin/logout",
    refresh: "/admin/refresh-token",
    me: "/admin/me",
    list: "/admin",
    create: "/admin/create",
    detail: (id: string) => `/admin/${id}`,
    update: (id: string) => `/admin/${id}`,
    delete: (id: string) => `/admin/${id}`,
    toggleStatus: (id: string) => `/admin/${id}/status`,
    forceLogout: (id: string) => `/admin/${id}/force-logout`,
    changePassword: "/admin/change-password",
    updateProfile: "/admin/profile",
  },
  product: {
    list: "/product/admin/list",
    detail: (id: string) => `/product/admin/${id}`,
    create: "/product/admin/create",
    update: (id: string) => `/product/admin/update/${id}`,
    delete: (id: string) => `/product/admin/delete/${id}`,
    upload: "/product/admin/upload",
    uploadVideo: "/product/admin/upload-video",
    uploadOgImage: "/product/admin/upload-ogImage",
  },
  variant: {
    upload: "/variant/admin/upload",
  },
  category: {
    list: "/category/admin/list",
    all: "/category/all",
    selectCategory: "/category/admin/select-category",
    detail: (id: string) => `/category/${id}`,
    create: "/category/admin/create",
    update: (id: string) => `/category/admin/update/${id}`,
    delete: (id: string) => `/category/admin/delete/${id}`,
    upload: "/category/admin/upload",
  },
  brand: {
    list: "/brand/admin/list",
    all: "/brand/admin/all",
    detail: (id: string) => `/brand/admin/${id}`,
    create: "/brand/admin/create",
    update: (id: string) => `/brand/admin/update/${id}`,
    delete: (id: string) => `/brand/admin/delete/${id}`,
    upload: "/brand/admin/upload",
  },
  banner: {
    list: "/banner/admin",
    detail: (id: string) => `/banner/admin/${id}`,
    create: "/banner/admin/create",
    update: (id: string) => `/banner/admin/update/${id}`,
    delete: (id: string) => `/banner/admin/delete/${id}`,
    upload: "/banner/admin/upload",
  },
  article: {
    list: "/article/list",
    detail: (id: string) => `/article/${id}`,
    create: "/article/admin/create",
    update: (id: string) => `/article/admin/update/${id}`,
    delete: (id: string) => `/article/admin/delete/${id}`,
    upload: "/article/admin/upload",
  },
  page: {
    list: "/page/list",
    detail: (id: string) => `/page/${id}`,
    create: "/page/admin/create",
    update: (id: string) => `/page/admin/update/${id}`,
    delete: (id: string) => `/page/admin/delete/${id}`,
  },
  order: {
    list: "/order",
    detail: (id: string) => `/order/${id}`,
    updateStatus: (id: string) => `/order/${id}/status`,
    delete: (id: string) => `/order/${id}`,
  },
  review: {
    list: "/review/admin",
    create: "/review/admin/create",
    update: (id: string) => `/review/admin/update/${id}`,
    delete: (id: string) => `/review/admin/delete/${id}`,
  },
  dashboard: {
    stats: "/dashboard/stats",
    chart: "/dashboard/chart",
  },
  cache: {
    revalidate: "/cache/revalidate",
  },
} as const;
